import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FieldHeader from './FieldHeader';
import { formStyleConstants } from '../../utils/constants/form-style-constants';

class FormCheckboxInput extends Component {
    render() {
        const {
            formRef,
            name,
            label,
            headerTitle,
            headerText,
            onChange,
            defaultValue
        } = this.props;
        const fieldClassName = name || formStyleConstants.customFieldClassName;

        return (<Fragment>
            <FieldHeader fieldName={name} headerTitle={headerTitle} headerText={headerText}>
            </FieldHeader>
            <div
                ref={formRef}
                className={`form-field auto-mt-xs ${fieldClassName.toLowerCase()}-field`}
                data-dc-component='form-field'
                data-form-control
            >
                <label className="form-switch">
                    <input
                        type='checkbox'
                        className='form-checkbox__checkbox visually-hidden'
                        name={name}
                        id={label}
                        onChange={onChange}
                        checked={defaultValue}
                    /><i></i>{label}
                </label>
            </div>
        </Fragment>
        );
    }
}

FormCheckboxInput.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    defaultValue: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

export default FormCheckboxInput;
